import React, { useState } from "react";
import { Card, Form, Button, Alert, Container, Spinner, InputGroup } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import { Envelope, ShieldLock } from "react-bootstrap-icons";
const temaCurenta = localStorage.getItem("theme") || "light";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setError("");
      setLoading(true);
      await login(email, password, rememberMe);
    } catch (err) {
      setError("Email sau parolă incorectă.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center position-relative overflow-hidden login-page-container"
      style={{
        height: "100vh",
        transition: "background 0.3s ease",
      }}
    >
      {/* 1. Straturile de fundal animate*/}
      <div className="fundal-abstract">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
      </div>

      {/* 2. Cardul de autentificare */}
      <Card
        className="shadow-lg border-0 rounded-4 p-3 animatie-card"
        style={{
          background:
            temaCurenta === "dark"
              ? "rgba(15, 23, 42, 0.65)"
              : "rgba(255, 255, 255, 0.7)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          border:
            temaCurenta === "dark"
              ? "1px solid rgba(255, 255, 255, 0.1)"
              : "1px solid rgba(255, 255, 255, 0.4)",
          color: temaCurenta === "dark" ? "#f8fafc" : "#212529",
          width: "100%",
          maxWidth: "460px",
          minWidth: "360px",
        }}
      >
        <Card.Body>
          <div className="text-center mb-3">
            <img
              src="logo512.png"
              alt="Logo"
              className="img-fluid logo-animat"
              style={{ width: "170px", height: "170px" }}
            />
          </div>
          <div className="text-center mb-4">
            <h2
              style={{ color: temaCurenta === "dark" ? "#f8fafc" : "#4f7a63" }}
            >
              Situația exploatării
            </h2>
            <p className="fw-light">Versiunea 1.4.3</p>
          </div>

          {error && (
            <Alert variant="danger" className="small animatie-eroare">
              {error}
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label className="small fw-bold">Email</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <Envelope size={18} />
                </InputGroup.Text>
                <Form.Control
                  type="email"
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />
              </InputGroup>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="small fw-bold">Parolă</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <ShieldLock size={18} />
                </InputGroup.Text>
                <Form.Control
                  type="password"
                  required
                  onChange={(e) => setPassword(e.target.value)}
                />
              </InputGroup>

              <div className="d-flex justify-content-center mt-3">
                <Form.Check
                  type="checkbox"
                  className="text-muted d-flex align-items-center"
                  id="rememberMeCheckbox"
                >
                  <Form.Check.Input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <Form.Check.Label className="ms-2 mt-1">
                    Rămâi autentificat
                  </Form.Check.Label>
                </Form.Check>
              </div>
            </Form.Group>

            <Button
              disabled={loading}
              variant="success"
              className="w-100 fw-bold py-2"
              type="submit"
            >
              {loading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                "Accesează platforma"
              )}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Login;
